/**
 * TIME Inside — Prodotti (biblioteca digitale)
 * Solo i contenuti con copertina reale caricata dall'utente. Nessun placeholder.
 */

export const PRODUCTS = {
  libri: {
    section: "Libri",
    parentTo: "/prodotti",
    parentLabel: "Torna a Prodotti",
    basePath: "/prodotti/libri",
    items: [
      {
        slug: "time-il-libro-del-tempo",
        title: "TIME",
        subtitle: "Il Libro del Tempo",
        author: "Gianluca Giardini",
        cover: "/covers/time-il-libro-del-tempo.png",
        // === Prodotto acquistabile ufficiale (Sprint E-commerce v1) ===
        buyable: true,
        detailPath: "/prodotti/libri/time-il-libro-del-tempo",
        price: 27,
        format: "PDF (digitale)",
        version: "1.0",
        // Stripe lookup key (deve corrispondere al prezzo creato in setup_stripe.py)
        stripeLookupKey: "time_book_digital",
        paperbackPrice: 14.9,
        paperbackUrl:
          "https://www.amazon.it/TIME-libro-Tempo-Gianluca-Giardini/dp/B0GCMTDRCZ?ref_=ast_author_mpb",
      },
      {
        slug: "le-5-regole-dell-equilibrio",
        title: "Le 5 Regole dell'Equilibrio",
        subtitle: "Come restare centrati senza fermarsi mai",
        author: "Gianluca Giardini",
        cover: "/covers/le-5-regole-dell-equilibrio.png",
      },
    ],
  },
  guide: {
    section: "Guide",
    parentTo: "/prodotti/risorse",
    parentLabel: "Torna a Risorse",
    basePath: "/prodotti/risorse/guide",
    items: [
      {
        slug: "ogni-problema-ha-il-suo-tempo",
        title: "Ogni Problema ha il suo Tempo",
        subtitle: null,
        author: "Gianluca Giardini",
        cover: "/covers/ogni-problema-ha-il-suo-tempo.png",
      },
      {
        slug: "la-chiave-universale-per-il-successo",
        title: "La Chiave Universale per il Successo",
        subtitle: "Sei tu · Come cambiare vita in soli 10 giorni",
        author: "Gianluca Giardini",
        cover: "/covers/la-chiave-universale-per-il-successo.png",
      },
    ],
  },
  manuali: {
    section: "Manuali",
    parentTo: "/prodotti/risorse",
    parentLabel: "Torna a Risorse",
    basePath: "/prodotti/risorse/manuali",
    items: [
      {
        slug: "disciplinati",
        title: "Disciplinati",
        subtitle: "È come camminare sui vetri nella tempesta",
        author: "Gianluca Giardini",
        cover: "/covers/disciplinati.png",
      },
    ],
  },
  dossier: {
    section: "Dossier",
    parentTo: "/prodotti/risorse",
    parentLabel: "Torna a Risorse",
    basePath: "/prodotti/risorse/dossier",
    items: [
      {
        slug: "dossier-riservato",
        title: "Dossier Riservato",
        subtitle: null,
        author: null,
        cover: "/covers/dossier-riservato.png",
      },
    ],
  },

  // Servizi
  consulenze: {
    section: "Consulenze",
    parentTo: "/servizi",
    parentLabel: "Torna a Servizi",
    basePath: "/servizi/consulenze",
    aspect: "square",
    items: [
      {
        slug: "maps-mind",
        title: "MAPS MIND",
        subtitle: "Mindset & Disciplina · Consulenza di allineamento",
        author: null,
        cover: "/images/maps-mind.png",
      },
    ],
  },
  sessioni: {
    section: "Sessioni",
    parentTo: "/servizi",
    parentLabel: "Torna a Servizi",
    basePath: "/servizi/sessioni",
    aspect: "square",
    items: [
      {
        slug: "sessione-time",
        title: "SESSIONE TIME",
        subtitle: "Verità sul proprio rapporto con il tempo",
        author: null,
        cover: "/images/sessione-time.png",
      },
    ],
  },

  // Percorsi
  timeImmersion: {
    section: "TIME IMMERSION",
    parentTo: "/percorsi",
    parentLabel: "Torna a Percorsi",
    basePath: "/percorsi/time-immersion",
    aspect: "square",
    items: [
      {
        slug: "time-immersion",
        title: "TIME IMMERSION",
        subtitle: "Guarda il tempo come un astronomo guarda le stelle",
        author: null,
        cover: "/images/time-immersion.png",
      },
    ],
  },
  trasfoproduct: {
    section: "TRASFOPRODUCT 6/12 mesi",
    parentTo: "/percorsi",
    parentLabel: "Torna a Percorsi",
    basePath: "/percorsi/trasfoproduct",
    aspect: "square",
    items: [
      {
        slug: "trasfoproduct",
        title: "TRASFOPRODUCT",
        subtitle: "Trasfoprodotto · Il prodotto è la persona",
        author: null,
        cover: "/images/trasfoproduct.png",
      },
    ],
  },
};

export function findProduct(slug) {
  for (const key of Object.keys(PRODUCTS)) {
    const collection = PRODUCTS[key];
    const item = collection.items.find((i) => i.slug === slug);
    if (item) return { ...item, collection };
  }
  return null;
}
